import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { App } from "./App";
import { PlanPrintPage } from "./components/PlanPrint";
import { readPlanPrintUrl } from "./lib/plan-export";
import "./styles.css";

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, staleTime: 5_000 } },
});

// The board's Export PDF opens the printable plan in a tab of its own, at this same address.
const printPlan = readPlanPrintUrl(window.location.search);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      {printPlan ? <PlanPrintPage request={printPlan} /> : <App />}
    </QueryClientProvider>
  </StrictMode>,
);
